import React from 'react';
import Draggable from 'react-draggable';
import storeManager from '../../store/StoreManager';
import createShapes from '../utils/CreateShapes';
import dragManager from '../utils/DragManager';
import { changeBackgroundContent } from '../../actions/CurrentSlideActions';
import properties from '../../constants/Properties';
import { getTouchPosition } from '../utils/TransformToolUtils';
import platformDetection from '../../components/utils/PlatformDetection';
import mouseUtils from '../../components/utils/MouseUtils';
import toolTipManager from '../../components/utils/ToolTipManager';
import videoUtils from '../../components/utils/VideoUtils';
import appParameters from '../../components/utils/AppParameters';
import { showAudioAlert } from '../../actions/MenuActions';
import saveManager from '../utils/SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import masterUniverseUtils from '../utils/MasterUniverseUtils';
import hoverManager from '../utils/HoverManager';
import locales from '../../locales/LocalesManager';
import mindMapUtils from '../utils/MindMapUtils';

export const ListItemRenderer = React.createClass({
    getInitialState () {
        if (masterUniverseUtils.useThumbnailsLazyLoading(this.props.usePagination)) {
            return {
                isOver: false,
                clientX: 0,
                clientY: 0,
                scrollPosition: 0,
                thumbnailLoaded: false
            };
        } else {
            return {
                isOver: false,
                clientX: 0,
                clientY: 0,
                scrollPosition: 0,
                thumbnailLoaded: true
            };
        }
    },
    componentDidMount() {
        this.initElements();
    },
    refreshForScroll(position) {
        if (!masterUniverseUtils.useThumbnailsLazyLoading(this.props.usePagination))
            return;

        this.setState({
            scrollPosition: position
        });
    },
    initElements() {
        if (masterUniverseUtils.useThumbnailsLazyLoading(this.props.usePagination))
            this.props.addRefreshHandler(this.refreshForScroll, this.props.index);

        const gap = 2;
        const width = 100;

        var itemRendererStyle = {
            position: 'relative',
            width: width,
            textAlign: 'center',
            display: 'inline-block',
            paddingTop: gap,
            paddingLeft: gap,
            WebkitUserSelect: 'none',
            userSelect: 'none',
            cursor: '-webkit-grab'
        };

        const thumbHolderWidth = width;
        const thumbHolderHeight = width * 3/4;

        const thumbHolderStyle = {
            width: thumbHolderWidth,
            height: thumbHolderHeight,
            background: this.props.backgroundColor,
            display: 'block',
            top: 0
        };

        var imageStyle;
        var imageWidth;
        var imageHeight;

        imageWidth = thumbHolderWidth;
        imageHeight = thumbHolderHeight;

        imageStyle = {
            position: 'absolute',
            width: imageWidth,
            height: imageHeight,
            left: thumbHolderWidth / 2 - imageWidth / 2 + 2,
            top: thumbHolderHeight / 2 - imageHeight / 2,
            display: 'block'
        };

        let frameDisplayState;

        if (this.state.isOver == true)
            frameDisplayState = 'block';
        else
            frameDisplayState = 'none';

        const boderWidth = 1;

        var frameStyle = {
            width: width,
            height: width * 3/4 + 19 - 2 * boderWidth,
            borderWidth: boderWidth,
            borderStyle: 'solid',
            borderColor: '#c05600',
            position: 'absolute',
            top: 0,
            left: 0,
            display: frameDisplayState
        };

        var fontStyle = {
            fontSize: 10,
            height: 15,
            width: width - 6,
            paddingLeft: 3,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            background: 'white',
            top: 0
        };

        let src;

        if (this.props.isMedia) {
            if (this.props.item.thumbnailUrl)
                src = this.props.item.thumbnailUrl;
            else
                src = this.props.item.thumb;
        } else {
            if (this.props.item && this.props.item.href && (this.props.item.href.indexOf('cartoonist_background_halloween') != -1 || this.props.item.href.indexOf('nature_dinosaurs_Trex_walking_01') != -1 || this.props.item.href.indexOf('easter_religious_angel_01') != -1)) {
                src = this.props.item.href;
            } else {
                if (appParameters.clipartId == 111 || (this.props.isBackground && (appParameters.clipartId == 75463385 || appParameters.clipartId == 92167535) && this.props.item.href && this.props.item.href.indexOf('cartoonist_background_halloween') != -1)) // for Halloween there is something wrong with the backgrounds generation
                    src = this.props.item.href;
                else
                    src = this.props.item.thumbnailUrl;
            }
        }

        var visibleFrame = 'none';
        var visibleBorder = 'none';
        var dragOffset = 17;

        if (this.props.isBackground) {
            visibleFrame = 'block';

            if (this.props.item.logicalName == '')
                visibleBorder = 'solid';

            fontStyle.position = 'relative';
            fontStyle.top = -8;
            fontStyle.height = 13;
            frameStyle.height = frameStyle.height - 12;
            itemRendererStyle.paddingTop = 0;
            itemRendererStyle.height = thumbHolderHeight + 5;
            itemRendererStyle.marginTop = -11;

            if (platformDetection.isTouchableDevice() == true)
                itemRendererStyle.marginTop = 0;

            dragOffset = 5;
        }

        const offsetY = (imageWidth * 3/4 - imageWidth * 9/16) / 2;
        const topBackground = {
            position: 'absolute',
            top: 0,
            left: 2,
            background: 'white',
            width: imageWidth,
            height: offsetY,
            display: visibleFrame,
            borderBottomStyle: visibleBorder,
            borderBottomWidth: 1,
            borderBottomColor: '#C0C0C0'
        };

        const bottomBackground = {
            position: 'absolute',
            top: imageHeight - offsetY,
            left: 2,
            background: 'white',
            width: imageWidth,
            height: offsetY,
            display: visibleFrame,
            borderTopStyle: visibleBorder,
            borderTopWidth: 1,
            borderTopColor: '#C0C0C0'
        };

        var draggleStyle = {
            width: width,
            height: width * 3/4 + dragOffset,
            position: 'absolute',
            top: 0,
            background: 'red',
            opacity: 0,
            display: 'block'
        };

        var imageElement =
            <span style={thumbHolderStyle}>
                <img alt='' aria-hidden='true' src={src} style={imageStyle}/>
                <span style={topBackground}/>
                <span style={bottomBackground}/>
            </span>;

        var imageElementEmpty =
            <span style={thumbHolderStyle}>
                <span style={imageStyle}/>
                <span style={topBackground}/>
                <span style={bottomBackground}/>
            </span>;

        var fontElement =
            <span style={fontStyle}>{this.getTitle()}</span>;

        var draggableElement =
            <Draggable axis='none' position={{x:0, y:0}} onStart={this.onDragStart} onDrag={this.onDragMove} onStop={this.onDragEnd}>
                <span style={draggleStyle}/>
            </Draggable>;


        var uploadButton;

        if (this.props.item && this.props.item.isUploadButton) {
            var uploadItemRendererStyle = {
                position: 'relative',
                width: width,
                paddingTop: gap,
                paddingLeft: gap,
                display: 'inline-block',
                textAlign: 'center'
            };

            if (platformDetection.isIOS())
                uploadItemRendererStyle.height = 60;

            if (this.props.length < 2) {
                uploadItemRendererStyle.height = 60;
                uploadItemRendererStyle.paddingTop = 7;
            }

            const wrapperUploadButtonStyle = {
                width: width,
                height: this.props.isVideo ? 94 : 78,
                textAlign: 'center',
                display: 'block',
                top: 0
            };

            const uploadIconStyle = {
                position: 'absolute',
                top: this.props.isVideo ? 10 : 0,
                left: 21,
                color: '#2DE102',
                cursor: 'pointer'
            };

            if (platformDetection.isIOS()) {
                uploadButton =
                    <div style={uploadItemRendererStyle} onMouseDown={this.onUpload} onTouchStart={this.onUpload} onMouseOver={this.onUploadMouseIn} onMouseOut={this.onUploadMouseOut}>
                        <div style={wrapperUploadButtonStyle}>
                            <i style={uploadIconStyle} id='uploadButton' className="fa fa-plus-circle fa-4x"></i>
                        </div>
                    </div>;
            } else {
                uploadItemRendererStyle.paddingRight = 0;
                uploadItemRendererStyle.paddingBottom = 0;
                uploadItemRendererStyle.boxSizing = 'initial';
                uploadItemRendererStyle.fontSize = 'initial';
                uploadItemRendererStyle.borderStyle = 'none';
                uploadItemRendererStyle.background = 'none';

                uploadButton =
                    <button aria-label={locales.getCaption('UploadHover', 'myFiles')} style={uploadItemRendererStyle} onClick={this.onUpload} onTouchStart={this.onUpload} onMouseOver={this.onUploadMouseIn} onMouseOut={this.onUploadMouseOut}>
                        <span style={wrapperUploadButtonStyle}>
                            <i style={uploadIconStyle} id='uploadButton' className="fa fa-plus-circle fa-4x"></i>
                        </span>
                    </button>;
            }
        }

        if (platformDetection.isIOS() == true) {
            var frameElement = <div style={frameStyle}/>;

            this.setState({
                imageElement,
                imageElementEmpty,
                fontElement,
                draggableElement,
                itemRendererStyle,
                frameElement,
                uploadButton
            });
        } else {
            this.setState({
                imageElement,
                imageElementEmpty,
                fontElement,
                draggableElement,
                itemRendererStyle,
                frameStyle,
                uploadButton
            });
        }
    },
    onUpload(e) {
        if (mouseUtils.rejectMouseEvent(e) || this.isDisabled())
            return;

        window.parent.postMessage('openUploader', '*');
    },
    onUploadMouseIn () {
        var button = document.getElementById('uploadButton');
        hoverManager.show(button, 'uploadButton', 'right');
    },
    onUploadMouseOut () {
        hoverManager.hide();
    },
    onFocus() {
        var type = 'ListItemRenderer';

        if (this.props.isBackground == true)
            type = 'ListItemRendererBackground';

        toolTipManager.showToolTip(this.getTitle(), this.refs.itemRenderer, type, this.changeHoverState);
    },
    onBlur() {
        toolTipManager.hideToolTip();
    },
    onMouseIn () {
        if (this.isDisabled()) {
            this.setState({
                isMouseIn: true,
                thumbnailLoaded: true
            });

            return;
        }

        this.setState({
            isOver: true,
            thumbnailLoaded: true
        });

        var type = 'ListItemRenderer';

        if (this.props.isBackground == true)
            type = 'ListItemRendererBackground';

        toolTipManager.showToolTip(this.getTitle(), this.refs.itemRenderer, type, this.changeHoverState);
    },
    onMouseOut () {
        if (this.isDisabled()) {
            this.setState({
                isMouseIn: false,
                thumbnailLoaded: true
            });

            return;
        }

        this.setState({
            isOver: false,
            thumbnailLoaded: true
        });

        toolTipManager.hideToolTip();
    },
    changeHoverState(value) {
        this.setState({
            isOver: value,
            thumbnailLoaded: true
        });
    },
    changeFocusToShapeMenuButton() {
        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var shapeMenuButton = document.getElementById('shapeMenuButton');

            if (shapeMenuButton)
                shapeMenuButton.focus();
        }.bind(this), 300);
    },
    createShape (topLeftPosition) {
        const dispatch = storeManager.getStore().dispatch;

        if (this.props.isVideo || (this.props.item.href && (this.props.item.href.indexOf('video') !== -1 && this.props.item.href.indexOf('svg') === -1))) {
            if (createShapes.useVideoAsBackground)
                this.setVideoAsBackground(this.props.item, dispatch);
            else
                createShapes.createVideo(dispatch, this.props.item, topLeftPosition);
            return;
        }

        if (this.props.item && this.props.item.isPrint) { // added for CART-1463 ... just printable items can behave as banckground image
            this.setImageAsBackground(this.props.item, dispatch);
            return;
        }

        if (this.props.isBackground) {
            if (this.props.isMedia) { // is MyImages from Search
                if (createShapes.useImageAsBackground)
                    this.setImageAsBackground(this.props.item, dispatch);
                else {
                    if (mindMapUtils.isMindMapMode())
                        mindMapUtils.insertMediaNode(this.props.item);
                    else
                        createShapes.createImage(dispatch, this.props.item, topLeftPosition);

                    this.changeFocusToShapeMenuButton();
                }

                return;
            }

            if (this.props.isFrame) { // is Frames from Search
                if (createShapes.useFrameAsImage) {
                    if (this.props.item.moods && this.props.item.moods.length > 1) {
                        createShapes.createCharacter(dispatch, this.props.item, topLeftPosition);
                    } else {
                        createShapes.createImage(dispatch, this.props.item, topLeftPosition);
                    }

                    this.changeFocusToShapeMenuButton();

                    return;
                }
            } else { // is Background from Search or from the theme
                if (createShapes.useBackgroundAsImage && !this.props.item.noBackground) {
                    if (this.props.item.moods && this.props.item.moods.length > 1) {
                        createShapes.createCharacter(dispatch, this.props.item, topLeftPosition);
                    } else {
                        createShapes.createImage(dispatch, this.props.item, topLeftPosition);
                    }

                    this.changeFocusToShapeMenuButton();

                    return;
                }
            }

            let newContent = {};
            newContent.logicalName = this.props.item.logicalName;
            newContent.href = this.props.item.href;
            newContent.moods = this.props.item.moods;
            newContent.orgWidth = 0;
            newContent.orgHeight = 0;

            newContent.isVideo = false;
            newContent.volume = 0.5;
            newContent.inPoint = undefined;
            newContent.outPoint = undefined;
            newContent.theme = this.props.item.theme;

            if (this.props.item.noBackground) {
                newContent.fill = '#ffffff';
                newContent.fillOpacity = 1;
                newContent.stroke = '#ffffff';
                newContent.strokeOpacity = 0;
                newContent.logicalName = '';
                newContent.href = '';
                newContent.moods = [];
            }

            if (this.props.item.moods && this.props.item.moods.length > 0)
                newContent.frameLabel = this.props.item.moods[0];
            else
                newContent.frameLabel = ''; // TO DO: it's just for test until fix the moods problem

            dispatch(changeBackgroundContent(newContent));
            createShapes.updateThumbnail(dispatch);
            audioEditorUtils.addActionToHistory();
            saveManager.isContentChanged(true);

            if (platformDetection.isEdge()) { // CH-457: force to redraw again ... the second time works fine.
                setTimeout(function() {
                    createShapes.updateThumbnail(dispatch);
                }, 300);
            }
        } else {
            if (this.props.item.moods && this.props.item.moods.length > 1) {
                if (mindMapUtils.isMindMapMode())
                    mindMapUtils.insertMediaNode(this.props.item, true);
                else
                    createShapes.createCharacter(dispatch, this.props.item, topLeftPosition);
            } else {
                if (mindMapUtils.isMindMapMode())
                    mindMapUtils.insertMediaNode(this.props.item);
                else
                    createShapes.createImage(dispatch, this.props.item, topLeftPosition);
            }

            this.changeFocusToShapeMenuButton();
        }
    },
    setImageAsBackground(item, dispatch) {
        var imageObj = new Image();
        var self = this;

        imageObj.onload = function (e) {
            var orgWidth = e.target.width;
            var orgHeight = e.target.height;

            self.changeBackgroundProperties(item, dispatch, orgWidth, orgHeight);
        };

        imageObj.src = videoUtils.checkCacheBreaker(item.href);
    },
    changeBackgroundProperties(item, dispatch, orgWidth, orgHeight) {
        let newContent = {};
        newContent.logicalName = item.logicalName;
        newContent.href = item.href;
        newContent.moods = [];
        newContent.hotSpot = '';
        newContent.frameLabel = '';
        newContent.orgWidth = orgWidth;
        newContent.orgHeight = orgHeight;

        newContent.isVideo = false;
        newContent.volume = 0.5;
        newContent.inPoint = undefined;
        newContent.outPoint = undefined;

        if (item.contentItemId > 0)
            newContent.contentItemId = item.contentItemId;

        dispatch(changeBackgroundContent(newContent));
        createShapes.updateThumbnail(dispatch);
        audioEditorUtils.addActionToHistory();

        saveManager.isContentChanged(true);
    },
    setVideoAsBackground(item, dispatch) {
        videoUtils.updateContentFromCurrentSlide();

        let newContent = {};
        newContent.logicalName = item.logicalName;
        newContent.href = item.href;
        newContent.moods = [];
        newContent.hotSpot = '';
        newContent.frameLabel = '';

        newContent.isVideo = true;
        newContent.volume = 0.5;
        newContent.inPoint = undefined;
        newContent.outPoint = undefined;

        if (item.contentItemId > 0)
            newContent.contentItemId = item.contentItemId;

        videoUtils.changeVideoBackground = true;

        dispatch(changeBackgroundContent(newContent));
        createShapes.updateThumbnail(dispatch);
        dispatch(showAudioAlert(3));

        if (videoUtils.refreshItemRenderer)
            videoUtils.refreshItemRenderer();

        videoUtils.refreshItemRenderer = this.refreshElement;
    },
    getTitle() {
        if (this.props.item.title)
            return this.props.item.title;

        var title = '';

        if (this.props.item.noBackground == true)
            title = this.props.item.title;

        return title;
    },
    isVideoItem(item) {
        if (!item)
            return false;

        if (item.href && item.href.indexOf('video') !== -1 && item.href.indexOf('svg') === -1)
            return true;

        if (item.contentType && item.contentType.indexOf('video') != -1)
            return true;

        return false;
    },
    rejectMouseDownEvent(e) {
        if (platformDetection.isChromeBook()) {
            var currentTime = new Date().getTime();
            var lastClickTime = mouseUtils.mouseDownTime;

            if (lastClickTime != 0 && (currentTime - lastClickTime) < 100)
                return true;
            else
                return false;
        } else
            return false;
    },
    onMouseDown(e) {
        console.log('TestTime Mouse down : ' + new Date().getTime());

        if (mouseUtils.rejectMouseEvent(e) || this.isDisabled() || this.rejectMouseDownEvent(e))
            return;

        mouseUtils.mouseDownTime = new Date().getTime();
        mouseUtils.isDragEnd = false;

        toolTipManager.hideToolTip();

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (this.isVideoItem(this.props.item) && videoUtils.showVideoEditor()) {
            var currentTime = new Date().getTime();

            if (this.state.currentTime > 0 && (currentTime - this.state.currentTime) < 300) {
                if (videoUtils.loadedVideo && this.props.item.href == videoUtils.loadedVideo) {
                    videoUtils.autoPlayVideo();
                } else {
                    videoUtils.executeAutoPlay = true;
                }
            }

            this.setState({
                clientX: clientPosition.x,
                clientY: clientPosition.y,
                currentTime,
                thumbnailLoaded: true
            });
        } else {
            this.setState({
                clientX: clientPosition.x,
                clientY: clientPosition.y,
                thumbnailLoaded: true
            });
        }
    },
    rejectMouseUpEvent(e) {
        if (platformDetection.isChromeBook()) {
            var currentTime = new Date().getTime();
            var lastClickTime = mouseUtils.mouseUpTime;

            if (lastClickTime != 0 && (currentTime - lastClickTime) < 100)
                return true;
            else
                return false;
        } else
            return false;
    },
    onMouseUp(e) {
        console.log('TestTime Mouse Up : ' + new Date().getTime());

        if (mouseUtils.rejectMouseEvent(e) || this.isDisabled() || this.rejectMouseUpEvent(e))
            return;

        mouseUtils.mouseUpTime = new Date().getTime();

        if (mouseUtils.isDragEnd == true) {
            mouseUtils.isDragEnd = true;
            return;
        }

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5)
            this.createShape();
    },
    onClick() {
        console.log('TestTime Click : ' + new Date().getTime());
        var downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        mouseUtils.isDragEnd = false;

        this.createShape();
    },
    isDisabled() {
        return false;
    },
    onDragStart(e, coreEvent) {
        console.log('TestTime Drag start : ' + new Date().getTime());

        if (platformDetection.isTouchableDevice() == true  || this.isDisabled())
            return;

        mouseUtils.mouseDownTime = new Date().getTime();
        mouseUtils.isDragEnd = false;

        toolTipManager.hideToolTip();

        const clone = this.refs.itemRenderer;

        if (this.props.isBackground == true)
            clone.className = 'background';

        dragManager.prepareClone(clone, this.createShape, getTouchPosition(e));
    },
    onDragMove(e, coreEvent) {
        if (platformDetection.isTouchableDevice() == true  || this.isDisabled())
            return;

        dragManager.onDragMove(coreEvent.lastX, coreEvent.lastY);
    },
    onDragEnd(e, coreEvent) {
        console.log('TestTime Drag end : ' + new Date().getTime());

        if (platformDetection.isTouchableDevice() == true  || this.isDisabled())
            return;

        mouseUtils.isDragEnd = true;

        dragManager.onDragEnd(coreEvent.lastX, coreEvent.lastY);
    },
    isSelectionVisible() {
        var backgroundVideo = videoUtils.getBackgroundVideo();

        if (this.isVideoItem(this.props.item) && backgroundVideo != '') {
            if (this.props.item.href == backgroundVideo) {
                if (videoUtils.refreshItemRenderer == undefined)
                    videoUtils.refreshItemRenderer = this.refreshElement;

                return true;
            } else
                return false;
        } else
            return false;
    },
    refreshElement() {
        this.forceUpdate();
    },
    useThumbnail() {
        if (!masterUniverseUtils.useThumbnailsLazyLoading(this.props.usePagination))
            return true;

        if (this.state.thumbnailLoaded)
            return true;

        var defaultItemLines;

        if(platformDetection.isIOS()) {
            if (this.props.isSearch)
                defaultItemLines = 10;
            else
                defaultItemLines = 7;
        } else {
            if (this.props.isSearch)
                defaultItemLines = 12;
            else
                defaultItemLines = 12;
        }

        const state = storeManager.getState();
        var parentWidth = state.accordion.width;

        if (parentWidth == undefined)
            parentWidth = properties.BROWSER_WIDTH;

        var itemHeight = (this.props.isBackground || (this.props.item.href && this.props.item.href.indexOf('video') !== -1 && this.props.item.href.indexOf('svg') === -1)) ? 80 : 96; // 80 - backgrounds and videos, 96 - rest of ones
        var itemWidth = 102;
        var scrollWidth = 20;
        var realWidth = parentWidth - scrollWidth;
        var itemsPerLine = Math.floor(realWidth / itemWidth);
        var minimListHeight = itemHeight * defaultItemLines;
        var currentLine = Math.ceil((this.props.index + 1) / itemsPerLine);
        var currentPosition = currentLine * itemHeight;
        var scrollPosition = this.state.scrollPosition + minimListHeight;

        if (currentPosition <= scrollPosition) {
            setTimeout(function() {
                this.setState({
                    thumbnailLoaded: true
                });
            }.bind(this), 5);

            return true;
        } else
            return false;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (!this.state.thumbnailLoaded || this.state.imageElement != nextState.imageElement || this.state.isOver != nextState.isOver || this.state.frameStyle != nextState.frameStyle || this.state.isMouseIn != nextState.isMouseIn)
            return true;
        else
            return false;
    },
    render() {
        if (this.state == undefined || this.state.imageElement == undefined)
            return (<div/>);

        if (this.props.item && this.props.item.isUploadButton) {
            return (this.state.uploadButton);
        }

        var imgElement = this.useThumbnail() ? this.state.imageElement : this.state.imageElementEmpty;

        if (platformDetection.isIOS() == true) {
            return (
                <div ref="itemRenderer" id={'ListItemRenderer_' + this.props.index} style={this.state.itemRendererStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchStart={this.onMouseDown} onTouchEnd={this.onMouseUp}>
                    {imgElement}
                    {this.state.fontElement}
                    {this.state.frameElement}
                    {this.state.draggableElement}
                </div>
            );
        } else {
            var frameStyle = Object.assign({}, this.state.frameStyle);
            let frameDisplayState;

            if (this.state.isOver == true)
                frameDisplayState = 'block';
            else
                frameDisplayState = 'none';

            frameStyle.display = frameDisplayState;

            var style = Object.assign({}, this.state.itemRendererStyle);

            if (this.isDisabled())
                style.cursor = 'default';
            else
                style.cursor = '-webkit-grab';

            var iconVisible;

            if (this.isSelectionVisible())
                iconVisible = 'block';
            else
                iconVisible = 'none';

            const checkIconStyle = {
                position: 'absolute',
                bottom: 18,
                right: 5,
                display: iconVisible,
                width: 25,
                height: 25
            };

            style.paddingRight = 0;
            style.paddingBottom = 0;
            style.boxSizing = 'initial';
            style.fontSize = 'initial';
            style.borderStyle = 'none';
            style.background = 'none';

            return (
                <button aria-label={this.getTitle()} ref="itemRenderer" id={'ListItemRenderer_' + this.props.index} style={style} onClick={this.onClick} onFocus={this.onFocus} onBlur={this.onBlur} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onMouseDown={this.onMouseDown} onMouseUp={this.onMouseUp} onTouchStart={this.onMouseDown} onTouchEnd={this.onMouseUp}>
                    {imgElement}
                    {this.state.fontElement}
                    <img alt='' aria-hidden='true' style={checkIconStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/selectedThemeHover.png'}/>
                    <span style={frameStyle}/>
                    {this.state.draggableElement}
                </button>
            );
        }
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/accordion/ListItemRenderer.js
 **/